import { Suspense } from 'react';

import { ButtonPrimary } from '@comeon/ui';
import { debounce } from '@comeon/utility';
import { LogoBankID, Null } from '@comeon/vectors';

import { SmallerContainer } from '~/components/layout/mediaquery';
import Loading from '~/components/misc/loading';

import { BANKID_MODES } from './configs';

const BankIDWithoutForm = ({ title, onClick, mode = BANKID_MODES.LOGIN, loading }) => {
	// TODO: remove this after new registration flow is live
	const showLogo = mode !== BANKID_MODES.RETRIEVE_BALANCE;

	const debouncedHandler = debounce(onClick, 369);

	return (
		<div>
			{showLogo && (
				<div className="svg-logo-container">
					<Suspense fallback={<Null />}>
						<LogoBankID className="svg-logo" />
					</Suspense>
				</div>
			)}
			<div>
				<ButtonPrimary
					disabled={loading}
					onClick={debouncedHandler}
					type="submit"
					className="u-relative bank-id-button"
					title={title}
					dataAt="register-login-bankid-button"
				>
					{title}
				</ButtonPrimary>
				<SmallerContainer>{loading && <Loading />}</SmallerContainer>
			</div>
		</div>
	);
};

export default BankIDWithoutForm;
